import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';

export const TlsCertificateNameField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<>
			{restaurantForFullInfo?.tlsCertificateLevel === 'Restaurant' && (
				<FullInfoField label="tlsCertificateNameLabel" value={restaurantForFullInfo?.tlsCertificateName} />
			)}
		</>
	);
};
